import { render, staticRenderFns } from "./Devlist.vue?vue&type=template&id=0bb839a3&scoped=true"
import script from "./Devlist.vue?vue&type=script&lang=js"
export * from "./Devlist.vue?vue&type=script&lang=js"
import style0 from "./Devlist.vue?vue&type=style&index=0&id=0bb839a3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb839a3",
  null
  
)

export default component.exports